/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UsernameAvailability } from './UsernameAvailability';
import {
    UsernameAvailabilityFromJSON,
    UsernameAvailabilityFromJSONTyped,
    UsernameAvailabilityToJSON,
    UsernameAvailabilityToJSONTyped,
} from './UsernameAvailability';

/**
 * 
 * @export
 * @interface UsernameAvailabilityResponse
 */
export interface UsernameAvailabilityResponse {
    /**
     * 
     * @type {UsernameAvailability}
     * @memberof UsernameAvailabilityResponse
     */
    status: UsernameAvailability;
    /**
     * Present only when TAKEN. Free names derived from the one typed.
     * @type {Array<string>}
     * @memberof UsernameAvailabilityResponse
     */
    suggestions?: Array<string>;
}



/**
 * Check if a given object implements the UsernameAvailabilityResponse interface.
 */
export function instanceOfUsernameAvailabilityResponse(value: object): value is UsernameAvailabilityResponse {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function UsernameAvailabilityResponseFromJSON(json: any): UsernameAvailabilityResponse {
    return UsernameAvailabilityResponseFromJSONTyped(json, false);
}

export function UsernameAvailabilityResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UsernameAvailabilityResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'status': UsernameAvailabilityFromJSON(json['status']),
        'suggestions': json['suggestions'] == null ? undefined : json['suggestions'],
    };
}

export function UsernameAvailabilityResponseToJSON(json: any): UsernameAvailabilityResponse {
    return UsernameAvailabilityResponseToJSONTyped(json, false);
}

export function UsernameAvailabilityResponseToJSONTyped(value?: UsernameAvailabilityResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': UsernameAvailabilityToJSON(value['status']),
        'suggestions': value['suggestions'],
    };
}

